import { Stack, useTheme } from "@mui/material";
import type { FC, ReactNode } from "react";

type Props = {
	children: ReactNode;
	alignment: "start" | "end";
	startAdornment?: ReactNode;
	pending?: boolean;
};

export const ChatMessageBubble: FC<Props> = ({
	children,
	alignment,
	startAdornment,
	pending,
}) => {
	const { message } = useTheme().chat;
	const flexAlignment = alignment === "end" ? "flex-end" : "flex-start";

	return (
		<Stack direction="row" justifyContent={flexAlignment}>
			{startAdornment}

			<Stack
				maxWidth={message.maxWidth}
				alignItems={flexAlignment}
				gap={message.gap}
				style={{ opacity: pending ? message.pendingOpacity : 1 }}
			>
				{children}
			</Stack>
		</Stack>
	);
};
